import { app_comment } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  appCommentKeys,
  parseAppCommentKey,
} from '../cache-keys/appCommentKeys';
import { queryFunction } from '../query-function';
import { PatchComment } from '@axo/shared/data-access/types/app-comment';

interface UseAppComment {
  applicationID: string;
  patchData: PatchComment;
}

export function useGetAppComment(applicationID: string) {
  const api = useAPI();
  const cacheKey = appCommentKeys.root({ applicationID });

  return useQuery(
    cacheKey,
    queryFunction(app_comment.getAppComment(api), ({ queryKey }) =>
      parseAppCommentKey(queryKey)
    ),
    {
      enabled: api.token.length > 0 && !!applicationID,
    }
  );
}

export function usePatchAppComment() {
  const api = useAPI();
  const client = useQueryClient();

  return useMutation(
    ({ applicationID, patchData }: UseAppComment) =>
      app_comment.patchAppComment(api)({ applicationID, patchData }),
    {
      onSuccess: (_, params) => {
        return client.invalidateQueries(appCommentKeys.root(params));
      },
    }
  );
}
